module.exports = __webpack_public_path__ + "img/fabulous.72cd28b2.png";